import { makeEntityScaffold } from '@classpass/saga-tools';
export var classBundlesByMsa = makeEntityScaffold('SAGA.API.CLASS_BUNDLES', function (client, msaId) {
  return client.classBundles.getByMsa(msaId);
}, {
  defaultKey: 1
});
export var purchaseClassBundle = makeEntityScaffold('SAGA.API.PURCHASE_CLASS_BUNDLE', function (client, userId, bundleId) {
  return client.classBundles.purchaseBundle(userId, {
    versioned_bundle_id: bundleId
  });
});